module.exports = __webpack_public_path__ + "legacy-software-modernization.3mGXvrL8.svg";